type ExpirationConfig = {
  year?: number;
  minutes?: number;
};

type DateAdjustment = keyof ExpirationConfig;

type CookieOptionValue = string | number | boolean | Date | undefined;

export type CookieOptions = {
  expires?: Date | string;
  [key: string]: CookieOptionValue;
};

const dateTypes: Record<
  DateAdjustment,
  (date: Date, value: number) => Date
> = {
  year(date, value) {
    date.setFullYear(date.getFullYear() + value);
    return date;
  },
  minutes(date, value) {
    date.setMinutes(date.getMinutes() + value);
    return date;
  },
};

function getCookieExpirationDate(
  date: Date,
  config: ExpirationConfig,
): Date {
  let expirationDate = date;

  if (!(expirationDate instanceof Date)) expirationDate = new Date();

  Object.entries(config).forEach(([type, value]) => {
    const adjustDate = dateTypes[type as DateAdjustment];
    if (adjustDate && typeof value === 'number') {
      expirationDate = adjustDate(expirationDate, value);
    }
  });

  return expirationDate;
}

function setCookie(
  name: string,
  value: string | number | boolean,
  opt: CookieOptions = {},
): void {
  const options: CookieOptions = {
    path: '/',
    ...opt,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value,
  )}`;

  Object.entries(options).forEach(([key, optionValue]) => {
    updatedCookie += `; ${key}`;
    if (optionValue !== true) {
      updatedCookie += `=${optionValue}`;
    }
  });

  document.cookie = updatedCookie;
}

function getCookie(name: string): string | undefined {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
    ),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function deleteCookie(name: string): void {
  setCookie(name, '', {
    'max-age': -1,
  });
}

export { getCookieExpirationDate, setCookie, getCookie, deleteCookie };
